import React from 'react'
import strip from 'striptags'
import { omit, pick, isNil } from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
//import Select from '../../Select'
//import moment from 'moment'
import md5 from 'blueimp-md5'
//import Form from './../../Form'
import { compose, withState, withHandlers, lifecycle, withProps } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'
import { fetchingState } from '../../../helpers/hocs.js'
import { getIsLogged } from '../../../selectors/user.js'
import { claimAsLot, personData } from '../../../store/reducers/auth.js'
//import { getFundsList } from '../../../selectors/funds.js'
import { getLiteList } from '../../../store/reducers/liteFundlist'
import { uploadImage } from './../../../store/reducers/profile/uploadImage'
import Input from '../../Input'
import { checkEmail/*, checkPhone*/ } from './../../../containers/Signin'
import { getUser } from '../../../store/reducers/auth.js'
//import { get as getPerson } from '../../../store/reducers/persons/info'
import { getPersonInfo } from '../../../store/reducers/personProfile.js'
//import { getTotal, getFunds } from '../../store/reducers/funds/list.js'

import Loader from '../../OverlayLoader'
import Select from '../../Select.jsx'
// import moment from 'moment'

//компонент формы на странице профиля персоны
const PersonClaimForm = ({ inputCheck, isLogged, person, personInfo, setSelect, showCompleteMessage, initialPersonData, setFundId, setTmpData, fundArrObj, months, setText, submit, success, fetching, intl, setInput, errors, error, tmpData, proceed, items = [], upload, imagesState, images, imageRemove, }) => (
	<div className="Person">
		{!success && (
			<Loader loading={fetching} isOrange>
				<div className='person-data'>
					<div className='item person-info' style={{ paddingTop: "0px" }}>
						<div className='Profile__form'>
							<div className='Profile__input-group'>
								<Input
									name='firstname'
									onChange={setInput('firstname')}
									errors={errors}
									value={tmpData.firstname}
									label={'Имя*'}
								/>
								<Input
									name='middlename'
									onChange={setInput('middlename')}
									errors={errors}
									value={tmpData.middlename}
									label={'Отчество'}
								/>
								<Input
									name='lastname'
									onChange={setInput('lastname')}
									errors={errors}
									value={tmpData.lastname}
									label={'Фамилия*'}
								/>
								<Select
									items={{"male": "Мужской", "female": "Женский"}}
									value={tmpData.gender}
									onSubmit={setSelect("gender")}
									class="Select_theme_block Select_theme_gray_absolute"
									required
									placeholder="Пол*"
								/>
							</div>
							<div className='Profile__input-group'>

								<Input
									type='number'
									name='birthday'
									onChange={setInput('birthday')}
									errors={errors}
									value={tmpData.birthday}
									label={'День рождения*'}
								/>
								<Select
									class="Select_theme_block Select_theme_gray_absolute"
									name='birthmonth'
									value={tmpData.birthmonth}
									placeholder={intl.formatMessage({ id: 'profile_edit.month' })}
									
									items={months}
									onSubmit={proceed.bind(this, 'birthmonth')}
									required
								/>
							</div>
							<div className='Profile__input-group'>
								<Input
									type='tel'
									name='phone'
									onChange={setInput('phone')}
									errors={errors}
									value={tmpData.phone}
									label={'Телефон*'}
								/>
								<Input
									type='email'
									name='email'
									onChange={setInput('email')}
									errors={errors}
									value={tmpData.email}
									label={'email*'}
								/>
							</div>
							<Input
								name='job'
								onChange={setInput('job')}
								errors={errors}
								value={tmpData.job}
								label={'Должность*'}
							/>
							<Input
								name='company'
								onChange={setInput('company')}
								errors={errors}
								value={tmpData.company}
								label={'Компания*'}
							/>
							<Input
								name='articles'
								onChange={setInput('articles')}
								errors={errors}
								value={tmpData.articles}
								label={'Ссылки на социальные медиа и статьи'}
							/>
							<Input
								type='textarea'
								name='description'
								onChange={setInput('description')}
								errors={errors}
								value={tmpData.description}
								label={'Биография (500-1200 символов)*'}
								minRows={10}
								isTextarea
								length={tmpData.description ? tmpData.description.length : 0}
								minLength={500}
								maxLength={1200}
								height="372px"
							/>
							<Select
								//items={{0: "Фонд номер 1", 1: "Фонд номер 2"}} 
								items={fundArrObj}
								value={tmpData.fund}
								
								onSubmit={setSelect("fund")}
								class="Select_theme_block Select_theme_gray"

								required
								placeholder="Фонд, который вы хотите поддержать*"
							/>






							{/*<Input  
							name='facebookPage' 
							onChange = {setInput('facebookPage')} 
							errors = {errors} 
							value = {tmpData.facebookPage}
							label={'Страница в Facebook'}
						/>
						<br></br>
						<Input  
							name='instaLink' 
							onChange = {setInput('instaLink')} 
							errors = {errors} 
							value = {tmpData.instaLink}
							label={'Аккаунт в Instagram'}
						/>*/}
						</div>
						
							<div className='person-tmpPhotos'>
								<div className='person-tmpPhotos-title person-tmpPhotos-title_profile'>Прикрепить фото</div>
								
								{(personInfo && personInfo.tmpPhotos && personInfo.tmpPhotos.length > 0) &&
									<div className='person-tmpPhotos-items'>
									{personInfo.tmpPhotos.map((image, idx) =>
										<div key={idx} className='person-tmpPhoto-item'>
											<img src={`${process.env.REACT_APP_HOST}files/${image._id}/image/`} alt='img'/>
										</div>
									)}
									</div>
								}
								<div className='person-tmpPhotos-items'>
									<div className='person-tmpPhoto-item'>
										<input className='modal__photos-field' type='file' multiple onChange={upload} style={{ display: "none" }} id='person-photos' />
										<label htmlFor="person-photos">
											<div className='person-tmpPhoto-addBlock' />
										</label>
									</div>
								</div>
							</div>
						

						<div className='item _person-image'>
							<div className='modal__photos'>
								{/* <label className='AddPhoto' style={{marginBottom: Object.keys(imagesState).length > 0 ? '20px' : 0}}>
								Прикрепить фото
								<input className='modal__photos-field' type='file' multiple onChange={upload} />
							</label> */}
								<div className='modal__photos-preview'>
									{Object.keys(imagesState).map(key => (
										<div className='modal__photos-preview-item' key={key}>
											{(imagesState[key] < 100 || !images || !images[key])
												?
												<Loader isLight />
												:
												(<div className='modal__photos-preview-img'>
													<img src={images[key].url} alt={images[key].name} className='person-photo' />
													<span className='modal__photos-preview-overlay Text' onClick={imageRemove.bind(this, key)}>
														<span className='modal__photos-preview-overlay__after'>
															{intl.formatMessage({ id: 'profile_report.delete_photo' })}
														</span>
													</span>
												</div>)
											}
										</div>
									))}
								</div>
							</div>
						</div>
						<div className="Become-member__agreement">
							<label className='Become-member__agreement-container'>
								{/* <input type='checkbox' name='offerCheckbox' onChange={alert}/>  */}
								<input type='checkbox' name='offerCheckbox' onChange={inputCheck(this)} />
								<div className='Become-member__agreement-checkbox'>
									<div className='Become-member__agreement-checkbox-arrow'></div>
								</div>
								<span className='Become-member__agreement-text' style={{ color: "black" }}>Нажимая на кнопку «Отправить», я даю согласие на обработку своих персональных данных и соглашаюсь с условиями <a className='member-anketa-policyLink' target='_blank' rel='noopener noreferrer' href='/policy' style={{ textDecoration: "underline" }}><FormattedMessage id='sign_in.the_privacy_policy' /></a></span>
							</label>
						</div>
						{errors && errors.offerCheckbox && <span style={{ color: "red" }}><small>Необходимо согласиться с условиями</small></span>}
					</div>
					<button className='Button Button_black' onClick={submit} style={{ width: "100%", backgroundColor: "#ff5027" }}>
						<FormattedMessage id='claim.send' />
					</button>
				</div>
				{!isNil(success) && (<div className='Text'><FormattedMessage id='claim.error' /></div>)}
				{errors && Object.keys(errors).length > 0 && !(Object.keys(errors).length === 1 && errors.offerCheckbox) && <div style={{ marginTop: '10px', color: 'red' }} className='Text'>*Поле, обязательное для заполнения</div>}
			</Loader>
		)}
	</div>
)

const mapStateToProps = state => ({ isLogged: getIsLogged(state), ...state.images, fundArrObj: state.liteFundlist.items, ...state.profile.report, ...state.personProfile/*...state.persons.info,*/ })
const mapDispathToProps = dispatch => bindActionCreators({ claimAsLot, personData, uploadImage, getUser, getPersonInfo, getLiteList }, dispatch)

export default injectIntl(compose(
	fetchingState(),
	connect(mapStateToProps, mapDispathToProps),
	withState('text', 'setText', ''),
	withState('fund', 'setFundId', null),
	withState('imagesState', 'setImages', {}),  // image
	withState('success', 'setSuccess', null),
	withState('tmpData', 'setTmpData', {}),
	withState('errors', 'setErrors', {}),//ошибки заполнения формы
	withState('message', 'setMessage', ''),
	withState('months', 'setMonths', {}),

	fetchingState(),
	//fetchingState({ multi: true }),
	withProps(props => {
		let initialPersonData = {//промежуточный объект для хранения получаемой информации
			lastname: props.person.descriptions[0].lastname || null,
			firstname: props.person.descriptions[0].firstname || null,
			middlename: props.person.descriptions[0].middlename || null,
			job: props.person.descriptions[0].job || null,
			company: props.person.descriptions[0].company || null,
			gender: props.person.gender,
			birthday: props.person.birthday,
			birthmonth: props.person.birthmonth,
			phone: props.person.phone,
			email: props.person.email,
			articles: props.person.articles,
			description: props.person.description,
			fund: props.person.fund,
			//facebookPage: props.person.facebookPage,
			//instaLink: props.person.instaLink
		}
		return ({ initialPersonData })
	}),
	withHandlers({
		setText: ({ setText }) => e => {
			let value = strip(e.target.value)
			setText(value)
		},
		setInput: ({ setTmpData, tmpData }) => field => e => {//запись данных при записи в input
			if (field === 'birthday' && e.target.value.length > 2) return
			tmpData[field] = e.target.value
			setTmpData(tmpData)
		},
		setSelect: ({ setTmpData, tmpData }) => field => value => {
			tmpData[field] = value
			setTmpData(tmpData)
		},
		inputCheck: ({ setTmpData, tmpData }) => field => e => {
			if (e.target.name === 'isWhite') {
				tmpData['isOrange'] = false//(e.target.checked)
				setTmpData(tmpData)
			} else if (e.target.name === 'isOrange') {
				tmpData['isOrange'] = true
				setTmpData(tmpData)
			} else {
				tmpData[e.target.name] = e.target.checked
				setTmpData(tmpData)
			}
		},
		submit: ({ isLogged, getPerson, claimAsLot, person, getPersonInfo, showCompleteMessage, personData, getUser, fetchingWrap, setSuccess, onSuccess, tmpData, images, imagesState, setErrors, setImages, errors, error }) => async e => {
			e && e.preventDefault()
			let data = { ...tmpData }
			//если фото были загружены
			if (Object.values(images).length > 0) {
				images = Object.values(pick(images, Object.keys(imagesState))).map(el => el._id)
				data.photos = images;
			}

			let errors = {};
			if (!data.firstname) errors.firstname = true
			if (!data.lastname) errors.lastname = true
			if (!data.email || !checkEmail(data.email)) errors.email = true
			if (!data.phone) errors.phone = true
			if (!data.birthday) errors.birthday = true
			if (!data.job) errors.job = true
			// if (!data.company) errors.company = true
			// if (!data.fund) errors.fund = true
			//if (!data.offerCheckbox) errors.offerCheckbox = true
			//if (!data.images) errors.images = true
			if (!data.description || data.description.length < 500 || data.description.length > 1200) errors.description = true
			/*if (!data.articles || data.articles.length < 10) errors.articles = true
			if (!data.fundLink) errors.fundLink = true
			if (!data.visitsDates) errors.visitsDates = true*/
			if (!data.offerCheckbox) errors.offerCheckbox = true

			setErrors(errors)
			if (Object.keys(errors).length === 0) {

				let result = await personData(data);
				if (result === 200) {
					setImages({})
					showCompleteMessage(true)
					await getUser()
					await getPersonInfo()
					//await getPerson(person._id)
					//onSuccess && setTimeout(() => onSuccess(), 1000)
					// setTimeout(() => showCompleteMessage(false), 1500)
				} else setSuccess(false)
			}

		},
		proceed: ({ setTmpData, tmpData }) => (field, e) => {
			e && e.preventDefault && e.preventDefault()
			tmpData[field] = (e == null) ? e : Number(e)
			setTmpData(tmpData)
		},

		upload: ({ setImages, uploadImage, imagesState }) => e => {
			const files = e.target.files
			try {
				for (let i = 0; i < files.length; i++) { // images
					const file = files.item(i)

					imagesState[md5(file.name)] = 0
					setImages(imagesState)

					const onUpload = (e) => {
						imagesState[md5(file.name)] = Math.floor((e.loaded * 100) / e.total)
						setImages(imagesState)
					}
					uploadImage(file, onUpload)
				}
			} catch (e) {
				alert(e)
			}
		},
		imageRemove: ({ setImages, imagesState }) => (key, e) => {
			e && e.preventDefault()
			setImages(omit(imagesState, key))
		},
	}),
	lifecycle({
		async componentDidMount() {
			await this.props.getLiteList()

		},
		componentWillUnmount() {
			this.props.setSuccess(null)
			this.props.setImages({})
		},
		componentWillMount() {
			let months = { null: '\n' }//массив месяцев
			for (let i = 0; i < 12; i++) {
				months[i] = this.props.intl.formatMessage({ id: 'profile_edit.birthday.' + i })
			}
			this.props.setMonths(months)
			if (Object.keys(this.props.initialPersonData).length > 0) this.props.setTmpData(this.props.initialPersonData)
			this.props.getPersonInfo()
		},
		componentDidUpdate() {
			console.log("tmpData",this.props.tmpData);
		},
		componentWillReceiveProps(np) {
            console.log('пропсы на форме*******************', np)
        }

	})
)(PersonClaimForm))



// WEBPACK FOOTER //
// ./src/components/PersonProfile/Form/PersonFormProfile.jsx